﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import {
	getPhenologicalStates,
	getPhenologicalState,
	savePhenologicalState,
	deletePhenologicalState,
	deleteObjective,
	saveObjective,
	getObjectives,
	getObjective,
	deleteIrrigation,
	saveIrrigation,
	getIrrigations,
	getIrrigation,
} from "@/api/Maintainers/application_orders";

const keyObjectives = "objetivos_oa";
const keyPhenologicalState = "phenologinal_states";
const keyIrrigations = "irrigations";

// Phenological States
export function usePhenologicalState(selected) {
	return useQuery([keyPhenologicalState, selected], () => selected && getPhenologicalState({ selected }));
}

export function usePhenologicalStatePaginate(params) {
	return useQuery([keyPhenologicalState, params], () => getPhenologicalStates(params));
}

export function useMutatePhenologicalState(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(savePhenologicalState, {
		onSuccess: (response) => {
			const phenological_states = _.omit(response, "detail");
			const phenological_state = _.omit(response, keyPhenologicalState);

			queryClient.setQueryData([keyPhenologicalState, String(phenological_state.detail.id)], phenological_state);
			queryClient.setQueryData([keyPhenologicalState, params], phenological_states);

			if (params.search) {
				queryClient.invalidateQueries([keyPhenologicalState]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/configuracion/estado_fenologico_oa");
		},
	});
}

export function useMutateDeletePhenologicalState(params) {
	const queryClient = useQueryClient();

	return useMutation(deletePhenologicalState, {
		onSuccess: (response) => {
			queryClient.setQueryData([keyPhenologicalState, params], response);
		},
	});
}

// Objectives
export function useObjective(selected) {
	return useQuery([keyObjectives, selected], () => selected && getObjective({ selected }));
}

export function useObjectivePaginate(params) {
	return useQuery([keyObjectives, params], () => getObjectives(params));
}

export function useMutateObjective(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveObjective, {
		onSuccess: (response) => {
			const phenological_states = _.omit(response, "detail");
			const phenological_state = _.omit(response, keyObjectives);

			queryClient.setQueryData([keyObjectives, String(phenological_state.detail.id)], phenological_state);
			queryClient.setQueryData([keyObjectives, params], phenological_states);

			if (params.search) {
				queryClient.invalidateQueries([keyObjectives]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/configuracion/objetivos_oa");
		},
	});
}

export function useMutateDeleteObjective(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteObjective, {
		onSuccess: (response) => {
			queryClient.setQueryData([keyObjectives, params], response);
		},
	});
}

// Irrigations

export function useIrrigation(selected) {
	return useQuery([keyIrrigations, selected], () => selected && getIrrigation({ selected }));
}

export function useIrrigationPaginate(params) {
	return useQuery([keyIrrigations, params], () => getIrrigations(params));
}

export function useMutateIrrigation(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveIrrigation, {
		onSuccess: (response) => {
			const list = _.omit(response, "detail");
			const detail = _.omit(response, keyIrrigations);

			queryClient.setQueryData([keyIrrigations, String(detail.detail.id)], detail);
			queryClient.setQueryData([keyIrrigations, params], list);

			if (params.search) {
				queryClient.invalidateQueries([keyIrrigations]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/configuracion/riegos");
		},
	});
}

export function useMutateDeleteIrrigation(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteIrrigation, {
		onSuccess: (response) => {
			queryClient.setQueryData([keyIrrigations, params], response);
		},
	});
}
